import * as React from "react"
import IUserVm from "../../models/shared/IUserVm"
import LogoutButton from "../Buttons/LogoutButtonComponent"
import LoadingOverlay from "../../containers/Shared/LoadingOverlayContainer"
import i18n from "../../i18n/i18n"
import Toastr from "../../containers/Shared/ToastrContainer"

// const fsStyrLogo = require("../../images/fstyr_logo_transparent.png")
const fsStyrLogo = require("../../images/FSTYR_logo_blue.png")

interface IBorgerDkLayoutProps {
  title: string,
  links: JSX.Element[],
  routes: JSX.Element[],
  user?: IUserVm,
  useTbstLogo?: boolean
}

export class BorgerDkLayout extends React.Component<IBorgerDkLayoutProps> {
  public render() {
    const {
      title,
      links,
      routes,
      user,
      useTbstLogo
    } = this.props

    return (
      <div className="OIMSuite OIMLink container-fluid">
        <div className="row-fluid OIMLink-header">
          <div className="span12">
            {useTbstLogo &&
              <img src={fsStyrLogo} alt="borger.dks logo" className="pull-right" style={{ height: "60px" }} />
            }
            {!useTbstLogo &&
              <img src="//www.borger.dk/Style%20Library/gfx/logo-mini.png" alt="borger.dks logo" className="pull-right" />
            }
          </div>
        </div>
        <h1>
          <div className="confirmation">
            {i18n.t(title)}
          </div>
        </h1>
        <div className="row-fluid">
          <div className="span12">
            {links.length > 0 &&
              <div className="navbar">
                <div className="navbar-inner">
                  <ul className="nav">
                    {links}
                  </ul>
                  {user &&
                    <ul className="nav pull-right">
                      <li>
                        <LogoutButton user={user} />
                      </li>
                    </ul>
                  }
                </div>
              </div>
            }
            <div className="row-fluid">
              {routes}
            </div>
          </div>
        </div>
        <div className="row-fluid OIMLink-footer">
          <hr />
        </div>
        <Toastr />
        <LoadingOverlay />
      </div>
    )
  }
}
